<style scoped lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/stock/requisition/page" getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shengchangongdanhao')">
						<el-input v-model="yt.conditions.no"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shebeimingcheng')">
						<yi_cross_select multiple :component="'web_base_equipment_list'" :ids.sync="yt.conditions.equipmentId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('zhuangtai')">
						<el-select v-model="yt.conditions.status">
							<el-option :label="$t('weichuli')" :value="0"></el-option>
							<el-option :label="$t('yilingliao')" :value="1"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain>
							{{ $t('sousuo') }}
						</el-button>
						<el-button @click="yt.clear()">{{ $t('chongzhi') }}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<template #shifoubulu="scope">
				<span v-if="scope.row.type == 0">
					{{ $t('fou') }}
				</span>
				<span v-if="scope.row.type == 1">
					{{ $t('shi') }}
				</span>
			</template>
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button v-if="scope.row.status == 0" type="text" @click="yt.showEditDialog('lingliaochuku', scope.row, 'w2')">
							{{ $t('lingliaochuku') }}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('lingliaojilu', scope.row, 'w2');">
							{{ $t('lingliaojilu') }}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/production/woreportrecord/delete')">{{ $t('shanchu') }}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
			</template>
		</yi_curd_table>
		<el-dialog v-dialog-drag :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 领料出库 -->
			<template v-if="yt.editObj.action == 'lingliaochuku'">
				<div class="dialog-scroller">
					<out_stock></out_stock>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/customer/create')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '领料单-领料出库' } }">
						{{ $t('baocun') }}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'lingliaojilu'">

				<!-- <span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
						<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/customer/update')" type="primary">
							{{$t('baocun')}}
						</el-button>
					</span> -->
			</template>

		</el-dialog>
	</div>
</template>
<script type="text/javascript">
import out_stock from '@@/pages/web/production_management/picking/out_stock'
export default {
	name: 'web_production_management_picking_list',
	components: {
		out_stock
	},
	data() {
		return {
			list: [],
			columns: [
				{
					label: 'shengchangongdanhao',
					prop: 'no',
					width: 130,
				},
				{
					label: 'shebeimingcheng',
					prop: 'equipment.name',
					width: 130,
				},
				{
					label: 'wuliaobianma',
					prop: 'basicMaterial.code',
					width: 130,
				},
				{
					label: 'wuliaomingcheng',
					prop: 'basicMaterial.name',
					width: 130,
				}, {
					label: 'xuqiuliang/(Kg)',
					prop: 'quantityDemanded',
					width: 130,
				}, {
					label: 'yilingshuliang',
					prop: 'quantityAcquired',
					width: 130,
				}, {
					label: 'zhuangtai',
					prop: 'status',
					type: 'tag',
					tags: {
						0: {
							color: '#F56C6C',
							text: this.$t('weichuli')
						},
						1: {
							color: '#67C23A',
							text: this.$t('yilingliao')
						}
					},
				},

				{
					label: 'caozuo',
					type: 'slot',
					width: 200,
					fixed: 'right'
				}
			],
		};
	},
	created() {
		setTimeout(() => {
			this.yt.get(1);
			// this.$set(this.yt.conditions, 'createTimeStart', this.begin())
			// this.$set(this.yt.conditions, 'createTimeEnd', this.end())
			// this.yt.list = []
			console.log('kkkk', this.yt.conditions)
		}, 300)

	},
	methods: {
		exportExcel() {
			let params = this.yt.conditions
			return this.http.get('/web/report/export/wo_allot_record', {
				params
			}).then(res => {
				this.$message.success(this.$t(res.msg))
				this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
			}).catch(error => {
				this.$message.error(this.$t(error))
			})
		},
		begin() {
			const date = new Date()
			const begin = (new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' +
				' 00:00:00'))
				.getTime()
			return begin
		},
		end() {
			const date = new Date()
			const end = (new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date
				.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds())).getTime()
			return end
		},
		// 重置
		clear() {
			this.yt.conditions = {
				createTimeStart: this.begin(),
				createTimeEnd: this.end()
			}
			this.yt.list = []
		},
	},
};
</script>
